import { render, staticRenderFns } from "./employees.vue?vue&type=template&id=1cffb5c6&scoped=true&"
import script from "./employees.vue?vue&type=script&lang=js&"
export * from "./employees.vue?vue&type=script&lang=js&"
import style0 from "./employees.vue?vue&type=style&index=0&id=1cffb5c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cffb5c6",
  null
  
)

export default component.exports